import "core-js/modules/es6.object.keys.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/cellSets/initialState';
import { createHierarchyFromTree, createPropertiesFromTree } from 'redux/reducers/cellSets/helpers';
var cellSetsHierarchyLoaded = produce(function (draft, action) {
  var data = action.payload.data;

  // The hierarchy carries metadata only (no cellIds), so the rebuilt properties
  // have no cellId Sets yet. Carry over any Sets already loaded for sets that
  // still exist.
  var newProperties = createPropertiesFromTree(data);
  Object.keys(newProperties).forEach(function (key) {
    var _draft$properties$key;
    var existingCellIds = (_draft$properties$key = draft.properties[key]) === null || _draft$properties$key === void 0 ? void 0 : _draft$properties$key.cellIds;
    if (existingCellIds) {
      newProperties[key].cellIds = existingCellIds;
    }
  });
  draft.loading = false;
  draft.hierarchyLoaded = true;
  draft.hierarchy = createHierarchyFromTree(data);
  draft.properties = newProperties;
}, initialState);
export default cellSetsHierarchyLoaded;